import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import DevicesIcon from "@mui/icons-material/Devices";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import { drawer } from "../../style/style";
import { zewalogo_customer, logoStyle2 } from "../../style/style";
import HubIcon from "@mui/icons-material/Hub";

import { getKeyByValue } from "../../context/contextmanager";
import { customerContext } from "../../context/contexts";
import { getobj } from "../../apicall/apicall";

export default function UserDrawer(props) {
  const [logo, setlogo] = useState();
  const [buttonText, setbuttonText] = useState("Devices");

  const customercontext = useContext(customerContext);
  useEffect(() => {
    const customer_id = sessionStorage.getItem("customer_id");
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/get-customer/" + customer_id + "/";
    const res = getobj(url);
    res.then(function (r) {
      setlogo(r.data.logo);
      //console.log(r);
    });
  }, []);

  const history = useNavigate();

  const handleClick = (text) => {
    setbuttonText(text);
    if (text === "Logout") {
      handleLogout();
    } else {
      props.setsearch("");
      sessionStorage.setItem("page_number",1)
      props.setenter(false);
      const nm = getKeyByValue(customercontext.manage, true);
      customercontext.setmanage({
        ...customercontext.manage,
        [nm]: false,
        [text]: true,
      });
    }
  };
  const handleLogout = () => {
    sessionStorage.setItem("token", "");
    history({ pathname: "/" });
    window.location.reload(true);
    localStorage.setItem("role", "")
  };

  return (
    <div className="drawer-admin">
      <Drawer sx={drawer} variant="permanent" anchor="left">
        <div>
          <img
            style={logoStyle2}
            src="https://zewa-logo-bucket.s3.amazonaws.com/rpm-logo.png"
            alt="logo"
          />

          <List>
            {["Devices", "Hubs", "Settings", "Logout"].map((text, index) => (
              <ListItem
                key={text}
                disablePadding
                className={
                  text === buttonText ? "active drawer-item" : "drawer-item"
                }
              >
                <ListItemButton
                  onClick={() => {
                    handleClick(text);
                  }}
                >
                  <ListItemIcon>
                    {index === 0 && <DevicesIcon style={{ color: "white" }} />}
                    {index === 1 && <HubIcon style={{ color: "white" }} />}
                    {index === 2 && <SettingsIcon style={{ color: "white" }} />}

                    {index === 3 && <LogoutIcon style={{ color: "white" }} />}
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          {/* <img style={zewalogo_customer} src={logo} alt="cust-logo" /> */}
        </div>
      </Drawer>
    </div>
  );
}
